module.exports = __webpack_public_path__ + "img/jbs_jbt8023_1_1999.prt.fbccffa7.jpg";